export const PageSize = 10;

export default { PageSize };
